import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import { useTranslation } from 'react-i18next';

type FooterProps = {
    termsPath?: string;
    externalUrl: string;
    externalLabel?: string;
    externalMail?: string;
};

const Footer: React.FC<FooterProps> = ({
    termsPath = '/documents/algemene-voorwaarden.pdf',
    externalUrl,
    externalLabel = 'Lifesight.org',
    externalMail = 'info@lifesight.me',
}) => {
    const { t } = useTranslation();

    return (
        <footer className="app-footer">
            <div className="app-footer__inner">
                <a className="app-footer__link" href={termsPath} target="_blank" rel="noreferrer">
                    {t('components.footer.terms')}
                </a>
                <div className="app-footer__right">
                    <a className="app-footer__link" href={`mailto:${externalMail}`}>
                        {externalMail}
                    </a>
                    <a className="app-footer__link" href={externalUrl} target="_blank" rel="noreferrer">
                        {externalLabel}
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
